import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ConversationListStateType, ConversationResponseItem, DeleteMessageObj, Pagination } from 'src/shared/types/src';
import { sortArrayByTimestamp } from 'src/shared/utils/src';

const initialState: ConversationListStateType = {
  loading: true,
  paginatedLoading: false,
  conversations: [],
  currentPage: 1,
  canPaginate: true,
  currConversationID: undefined,
  totalUnreadConversationCount: 0,
  deleteMessageObj: null
};

const conversationSlice = createSlice({
  name: 'conversationSlice',
  initialState,
  reducers: {
    setConversationLoader: (
      state,
      action: PayloadAction<{ loading: boolean }>
    ) => {
      state.loading = action.payload.loading;
    },
    setConversationPaginatedLoader: (
      state,
      action: PayloadAction<{ paginatedLoading: boolean }>
    ) => {
      state.paginatedLoading = action.payload.paginatedLoading;
    },
    appendConversations: (
      state,
      action: PayloadAction<{ list: ConversationResponseItem[] }>
    ) => {
      console.log("list of conversartion : ", JSON.stringify(action.payload.list, null, 2));
      state.conversations.push(...action.payload.list);
      state.currentPage = state.currentPage + 1;
    },
    setCanPaginate: (state, action: PayloadAction<boolean>) => {
      state.canPaginate = action.payload;
    },
    resetConversationState: () => {
      return {
        ...initialState
      };
    },
    setConversationID: (state, action: PayloadAction<{ conversationID: string }>) => {
      state.currConversationID = action.payload.conversationID;
    },
    updateConversationById: (state, action: PayloadAction<{ conversationObj: ConversationResponseItem }>) => {
      const { conversationObj } = action.payload;
      const postList = state.conversations;
      const postIndex = state.conversations.findIndex((p) => p.conversationId === conversationObj.conversationId);
      if (postIndex === -1)
        return;

      const updatedObj: ConversationResponseItem = { ...postList[postIndex], ...conversationObj };
      const newArray = [
        ...postList.slice(0, postIndex),
        updatedObj,
        ...postList.slice(postIndex + 1),
      ];
      state.conversations = sortArrayByTimestamp(newArray);
    },
    updateConversationUnreadCountById: (state, action: PayloadAction<{ conversationId: string, updatedUnreadCount: number }>) => {
      const { conversationId, updatedUnreadCount } = action.payload;
      const list = state.conversations;
      const cIndex = state.conversations.findIndex((p) => p.conversationId === conversationId);
      if (cIndex === -1)
        return;
      console.log("updated count : ", updatedUnreadCount);
      const updatedObj: ConversationResponseItem = { ...list[cIndex], unreadCount: String(updatedUnreadCount) };
      state.conversations = [
        ...list.slice(0, cIndex),
        updatedObj,
        ...list.slice(cIndex + 1),
      ];
    },
    setTotalUnreadConversationCount: (state, action: PayloadAction<{ count: number }>) => {
      state.totalUnreadConversationCount = action.payload.count;
    },
    setDeleteMessageObj: (state, action: PayloadAction<{ msgObj: DeleteMessageObj }>) => {
      state.deleteMessageObj = action.payload.msgObj;
    },
    resetDeleteMessageObj: (state) => {
      state.deleteMessageObj = null;
    },
  },
});

export const ConversationActions = conversationSlice.actions;
export default conversationSlice.reducer;
